// extracted by mini-css-extract-plugin
export default {"skeleton":"styles_skeleton__MfZp3","shine":"styles_shine__Etdtw"};